import { Layout } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled.div`
  width: 100%;
  background: ${({ theme: { system } }) => system.background.fds_sys_color_background_gradient_B};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: none;
  }
`;

export const MobileContainer = styled.div`
  display: none;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: flex;
    width: 100%;
    background: ${({ theme: { system } }) => system.background.fds_sys_color_background_gradient_B};
  }
`;

export const LayoutCentered = styled(Layout.Centered)`
  max-width: 100%;
  padding: ${({ theme: { reference } }) => reference.dimension_16};
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_L};
  height: 100%;
  margin-bottom: ${({ theme: { reference } }) => reference.dimension_04};
  gap: ${({ theme: { reference } }) => reference.dimension_16};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`;
